/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Auto_SyncInputs */



/**
* | output |
* | --- |
* | "Automatic Sync" |
*
* @param {Signup_Compare_Auto_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_auto_sync = /** @type {((inputs?: Signup_Compare_Auto_SyncInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Auto_SyncInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic Sync")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic Sync")
	return /** @type {LocalizedString} */ ("Automatic Sync")
});